import Result from "@/core/common/Result";

export type ICadastrarVoucherUseCaseParams = {
  telefone: string;
  email: string;
  idVoucher: string;
};
export interface ICadastrarVoucherUsecase {
  cadastrar(params: ICadastrarVoucherUseCaseParams): Promise<Result<void>>;
}

export const cadastrarVoucherUsecaseDI = "cadastrarVoucherUsecase";
